<template>
  <form class="topup-form" @submit="submit">
    <div class="topup-form-frame">
      <div class="topup-loading" v-if="isLoading">{{ $t('view.userTerms.loading') }}</div>
      <div v-if="!isLoading">
        <h1>{{ $t('view.userTerms.header') }}</h1>
          <div class="topup-agreements">
            <div class="with-checkbox">
              <input type="checkbox" id="agreement" v-model="form.agreement" />
              <label class="check-label" for="agreement">
                <span class="check-label-box"></span>
                <span class="check-label-text" v-html="$t('view.userTerms.fieldTermsAgree')"></span>
              </label>
            </div>
          </div>
          <div class="rodo" v-html="$t('view.userTerms.rodoText')"></div>
          <div class="topup-form-buttons">
            <span></span>
            <button id="submit-agree"
                    type="submit"
                    :disabled="!isFormValid() || isLoading">
              {{ $t('view.userTerms.buttonNext') }} ›
            </button>
          </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { ROUTING } from '@/plus/const/routing.const'

export default {
  name: 'UserTerms',
  computed: {
    ...mapState({
      isLoading: state => state.terms.loading
    })
  },
  data () {
    return {
      form: {
        agreement: false
      }
    }
  },
  methods: {
    ...mapActions([
      'setUserTermsAgree',
      'getUserSession'
    ]),
    isFormValid () {
      return this.form.agreement
    },
    submit (e) {
      e.preventDefault()

      if (!this.isFormValid()) {
        return
      }

      this.setUserTermsAgree()
        .then(() => {
          this.$notify.success({
            message: this.$t('view.userTerms.messges.setTermsSuccess')
          })
          this.getUserSession()
            .finally(() => {
              this.$router.push(ROUTING.main)
            })
        })
        .catch(() => {
          this.$notify.error({
            message: this.$t('view.userTerms.messges.setTermsError')
          })
        })
    }
  }
}
</script>

<style src="../assets/scss/topup-form.scss" lang="scss"></style>
